import type { Dispatch, SetStateAction } from 'react'
import React from 'react'

import type { ScrollRef } from 'components/LayoutPage/LayoutScroll/LayoutScroll'
import type { IEmptyProps } from 'components/uiKit/Empty'
import Empty from 'components/uiKit/Empty'
import InfiniteLoadGrid from 'components/uiKit/InfiniteLoadGrid'
import type { ExternalImage } from 'gql/__generated__/graphql'

import ExternalImagesGridItem from './ExternalImagesGridItem'

interface IExternalImagesProps {
  data: ExternalImage[]
  onChangeSelection: Dispatch<SetStateAction<ExternalImage[]>>
  onClickItem: (item: ExternalImage) => void
  total: number
  selectedItems: ExternalImage[]
  loading: boolean
  resourceLink: string
  empty?: IEmptyProps
  clearQuery: () => void
  fetchMore?: () => Promise<unknown>
  chunkLoading?: boolean
  error?: boolean
  checkbox?: boolean
}

const ExternalImages = React.forwardRef<ScrollRef, IExternalImagesProps>(
  (
    {
      data,
      onChangeSelection,
      onClickItem,
      total,
      selectedItems,
      loading,
      clearQuery,
      fetchMore,
      empty,
      chunkLoading,
      error,
      resourceLink,
      checkbox
    },
    ref,
  ) => {
    if ((error || !data.length) && !loading) {
      return <Empty {...empty} grow />
    }

    return (
      <InfiniteLoadGrid
        chunkLoading={chunkLoading || loading}
        fetchMore={fetchMore}
        grid={{ width: '308px' }}
        hasMore={total > data.length}
        loading={loading}
        name='filePicker'
        padding='5px 0 20px'
        ref={ref}
      >
        {data.map((item, index) => (
          <ExternalImagesGridItem
            checkbox={checkbox}
            clearQuery={clearQuery}
            item={item}
            key={`${item.id}${index}`}
            onChangeSelection={onChangeSelection}
            onClick={onClickItem}
            resourceLink={resourceLink}
            selectedItems={selectedItems}
          />
        ))}
      </InfiniteLoadGrid>
    )
  },
)

ExternalImages.displayName = 'ExternalImages'

export default ExternalImages
